<template>
    <div class="text-center md:text-left">
        <h2 class="font-heading text-3xl mb-2 font-light">
            Newsletter Sign Up
        </h2>

        <p class="mb-2">
            The latest information on events, sales and offers. Sign up today for 10% off your first order.
        </p>

        <NewsletterSubscribe />
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import Input from '@/components/Input';
import Button from '@/components/Button';
import handleException from '../plugins/error-handler.client';
import NewsletterSubscribe from '@/components/forms/NewsletterSubscribe.vue';

export default {
    components: {
        NewsletterSubscribe,
    },
};
</script>
